import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/sdc/certificados/[id]/page.tsx");
